import React from 'react';
import { testimonials } from '../mock';
import { Star, Trophy } from 'lucide-react';

export default function Testimonials() {
  return (
    <section id="reviews" className="py-20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-emerald-500/30 bg-emerald-500/5 text-emerald-300 text-xs font-semibold">
            <Trophy size={12} /> Success Stories
          </div>
          <h2 className="mt-4 text-4xl md:text-5xl font-extrabold text-white tracking-tight">
            Students Who Made It
          </h2>
          <p className="mt-3 text-slate-400">Real results from real students</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="rounded-xl border border-white/5 bg-[#0f1725] p-6 hover:border-emerald-500/30 transition-colors"
            >
              <div className="flex items-start gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  loading="lazy"
                  decoding="async"
                  width="56"
                  height="56"
                  className="w-14 h-14 rounded-full object-cover border-2 border-emerald-500/30"
                />
                <div className="flex-1">
                  <h4 className="text-white font-bold">{t.name}</h4>
                  <p className="text-emerald-400 text-sm">{t.exam}</p>
                  <div className="mt-1 inline-flex items-center gap-1 px-2 py-0.5 rounded bg-amber-500/15 text-amber-300 text-xs font-semibold">
                    <Trophy size={10} /> {t.result}
                  </div>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={14} className="fill-amber-400 text-amber-400" />
                  ))}
                </div>
              </div>
              <p className="mt-4 text-slate-300 text-sm italic leading-relaxed">&ldquo;{t.text}&rdquo;</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
